import { render, staticRenderFns } from "./LBSearch.vue?vue&type=template&id=a543fd96&scoped=true"
import script from "./LBSearch.vue?vue&type=script&lang=js"
export * from "./LBSearch.vue?vue&type=script&lang=js"
import style0 from "./LBSearch.vue?vue&type=style&index=0&id=a543fd96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a543fd96",
  null
  
)

export default component.exports